import ReactEcharts from "echarts-for-react";
import _ from "lodash";
import { DateTime, Interval } from "luxon";
import { DateShift, Event, FShift } from "../../../../../types/types";
import { EquipmentTimelineData, PersonTimelineData } from "../../../../../stores/TabsStore";
import { hexColor, rgbColor } from "../../../../../enums/colors";
import { useMemo } from "react";
import { getCurrentStateColor } from "../../../../../lib/calculations";

// 0: "equipment_item_id"
// 1: "event_date"
// 2: "shift_date"
// 3: "start"
// 4: "start_ts"
// 5: "finish"
// 6: "finish_ts"
// 7: "duration"
// 8: "state"
// 9: "equipment_item_status"
// 10: "personnel_id"
// 11: "equipment_item_division_id"
// 12: "personnel_division_id"
// 13: "state_changed"
// 14: "status_changed"
// 15: "person_changed"
// 16: час
// 17: в перерыве или нет

const TimelineChart = ({events, shift, height, width}: {events: Event[]; shift: DateShift; height: string | number; width: string | number;}) => {
  const intervals = [
    Interval.fromDateTimes(shift.start_time, shift.end_time)
      .splitBy({ hour: 1 })
      .map((d) => d.start?.toISOTime({ includeOffset: false, suppressMilliseconds: true })),
    shift.end_time.toISOTime({ includeOffset: false, suppressMilliseconds: true }),
  ].flat();
  const shiftDuration = shift.end_time.toSeconds() - shift.start_time.toSeconds();

  const chartData = useMemo(() => {
    return events.map((item) => ({
      name: item[8],
      type: "bar",
      stack: "timeline",
      color:  getCurrentStateColor(String(item[8])),
      data: [item[7]]
    }))
  }, [events])

  const getOptions = () => ({
    tooltip: { show: false },
    grid: {
      left: "0%",
      right: "0%",
      bottom: -5,
      top: -5,
      containLabel: false,
    },
    animation: false,
    xAxis: [
      { show: false, max: shiftDuration },
      { show: false, data: intervals },
    ],
    yAxis: { show: false, type: "category" },
    series: chartData,
  });

  return <ReactEcharts option={getOptions()} notMerge={true} style={{ height: height, width: width }} opts={{ renderer: "canvas" }} />;
};

export default TimelineChart;